import {
	GridCellProps,
	GridColumnProps,
	GridHeaderCellProps,
} from "@progress/kendo-react-grid";
import CustomDropDownList from "ui/dropDown";
import { getPackagesApi, getProductsApi } from "api/common";
import { ListItemProps } from "@progress/kendo-react-dropdowns";
import React, { FC } from "react";
import { GridCommandCellMultiple } from "ui/grid/GridCommandCell";
import { NumericalCell, NumericalHeader } from "ui/grid/NumericalCellInput";
import { FooterAggregateSum } from "ui/grid/GridFooters";
import { CLASSNAME, ICON_NAMES } from "utils/constant";
import i18n from "../../../../i18n";
import { NumericalCellAutoFocus } from "ui/grid/NumericalCellInputFocus";

let t = i18n.t;

interface StepTwoGridColumnProps {
	update: (data: any, type?: "product" | "packaging" | "other") => void;
	openNoteModal: (props: GridCellProps) => void;
	onSelectPackage: (data: any) => void;
	startDeletingLine: (data: any) => void;
	hasMeetRequirement: (data: any, field: string) => boolean;
	showError: boolean;
	data: any[];
	onChange?: (data: any) => void;
	onBlur?: (data: any) => void;
	onFocus?: (data: any) => void;
	onValueChange?: (e: any) => void;
}

export const stepTwoGridColumns = ({
	showError,
	...prop
}: StepTwoGridColumnProps) => {
	const gridItems: GridColumnProps[] = [
		{
			field: "productId",
			title: t("Product"),
			// editable: true,
			className: `no-border col-min-width`,
			//	width: "350px",
			cells: {
				data: (props) => {
					let code = props.dataItem[props.field as any] || null;
					let display = props.dataItem["product"];
					let value = {} as any;
					if (code !== null) {
						value.id = code;
						value.name = display;
					}
					return (
						<td
							className="no-border col-min-width"
							style={{
								paddingLeft: "1px !important",
							}}
						>
							<CustomDropDownList
								data={[]}
								value={value}
								onSelect={(data) => {
									props.dataItem[props.field as any] = data.id;
									props.dataItem["product"] = data.name;
									props.dataItem["piecesMandatory"] =
										data.isNumberOfUnitsMandatory === true ? 1 : 0;
									prop.update(props.dataItem, "product");
								}}
								serverFilterApi={getProductsApi}
								defaultItem={{ id: null, name: "Velg Vare" }}
								filterable={true}
								serverFilter={true}
								textField={"name"}
								dataItemKey={"id"}
								showError={
									!prop.hasMeetRequirement(
										props.dataItem,
										props.field as any
									) && showError
								}
								borderColor="none"
							/>
						</td>
					);
				},
			},
		},
		{
			field: "packagingCode",
			title: t("Packaging"),
			className: ` no-border`,
			//	width: "350px",
			editable: true,

			cells: {
				data: (props) => {
					let code = props.dataItem[props.field as any] || null;
					let display = props.dataItem["packaging"];

					let value = {} as any;
					if (code !== null) {
						value.code = code;
						value.name = display;
					}
					return (
						<td className="no-border">
							<CustomDropDownList
								data={[]}
								value={value}
								// onChange={onChange}
								filterable={true}
								serverFilter={true}
								onSelect={(data) => {
									props.dataItem[props.field as any] = data.code;
									props.dataItem["packaging"] = data.name;
									prop.onSelectPackage(props.dataItem);
									// prop.update(props.dataItem, "packaging");
								}}
								defaultItem={{ code: null, name: t("ChoosePackaging") }}
								textField={"name"}
								dataItemKey={"code"}
								itemRender={itemRender}
								showError={
									!prop.hasMeetRequirement(
										props.dataItem,
										props.field as any
									) && showError
								}
								serverFilterApi={getPackagesApi}
								borderColor="none"
							/>
						</td>
					);
				},
			},
		},
		{
			field: "numberOfUnits",
			title: t("Units"),
			editable: true,
			width: "110px",

			cells: {
				data: (props) => (
					<NumericalCellAutoFocus {...props} {...prop} decimalScale={0} />
				),

				// headerCell: (props) => <NumericalHeader {...props} />,
				footerCell: (data) => (
					<FooterAggregateSum
						props={data}
						data={prop.data}
						field={"numberOfUnits"}
					/>
				),
			},

			headerClassName: CLASSNAME.TableNumeric,
			className: `${CLASSNAME.TableNumeric} no-border`,
		},
		{
			field: "numberOfPallets",
			title: t("Pallets"),
			editable: true,
			width: "110px",

			cells: {
				data: (props) => (
					<NumericalCellAutoFocus {...props} {...prop} decimalScale={0} />
				),

				// headerCell: (props) => <NumericalHeader {...props} />,
				footerCell: (data) => (
					<FooterAggregateSum
						props={data}
						data={prop.data}
						field={"numberOfPallets"}
					/>
				),
			},

			headerClassName: CLASSNAME.TableNumeric,
			className: `${CLASSNAME.TableNumeric} no-border`,
		},
		{
			field: "numberOfPieces",
			title: t("Pieces"),
			editable: true,
			width: "110px",

			cells: {
				data: (props) => (
					<NumericalCellAutoFocus
						{...props}
						{...prop}
						decimalScale={0}
						showError={
							!prop.hasMeetRequirement(props.dataItem, props.field as any) &&
							showError
						}
					/>
				),

				// headerCell: (props) => <NumericalHeader {...props} />,
				footerCell: (data) => (
					<FooterAggregateSum
						props={data}
						data={prop.data}
						field={"numberOfPieces"}
					/>
				),
			},

			headerClassName: CLASSNAME.TableNumeric,
			className: `${CLASSNAME.TableNumeric} no-border`,
		},

		{
			field: "averageLiveWeightKg",
			title: t("Average"),
			editable: true,
			//format: "{0:d}",
			width: "140px",
			cells: {
				data: (props) => (
					<NumericalCellAutoFocus
						{...props}
						{...prop}
						decimalScale={2}
						fixedDecimalScale={true}
					/>
				),

				footerCell: (data) => (
					<FooterAggregateSum
						props={data}
						data={prop.data}
						decimalScale={2}
						fixedDecimalScale={true}
						field={"averageLiveWeightKg"}
					/>
				),
				// headerCell: (props) => <NumericalHeader {...props} />,
			},

			headerClassName: CLASSNAME.TableNumeric,
			className: `${CLASSNAME.TableNumeric} no-border`,
		},

		{
			field: "grossLiveWeightKg",
			title: t("GrossWeight"),
			editable: true,
			//format: "{0:d}",
			width: "140px",
			cells: {
				data: (props) => (
					<NumericalCellAutoFocus
						{...props}
						{...prop}
						decimalScale={2}
						fixedDecimalScale={true}
						showError={
							!prop.hasMeetRequirement(props.dataItem, props.field as any) &&
							showError
						}
					/>
				),

				footerCell: (data) => (
					<FooterAggregateSum
						props={data}
						data={prop.data}
						decimalScale={2}
						fixedDecimalScale={true}
						field={"grossLiveWeightKg"}
					/>
				),
				// headerCell: (props) => <NumericalHeader {...props} />,
			},

			headerClassName: CLASSNAME.TableNumeric,
			className: `${CLASSNAME.TableNumeric} no-border`,
		},
		{
			field: "netLiveWeightKg",
			title: t("NetWeight"),
			editable: true,
			//format: "{0:d}",
			width: "140px",
			cells: {
				data: (props) => (
					<NumericalCellAutoFocus
						{...props}
						{...prop}
						decimalScale={2}
						fixedDecimalScale={true}
						showError={
							!prop.hasMeetRequirement(props.dataItem, props.field as any) &&
							showError
						}
					/>
				),
				footerCell: (data) => (
					<FooterAggregateSum
						props={data}
						data={prop.data}
						decimalScale={2}
						fixedDecimalScale={true}
						field={"netLiveWeightKg"}
					/>
				),
				// headerCell: (props) => <NumericalHeader {...props} />,
			},

			headerClassName: CLASSNAME.TableNumeric,
			className: `${CLASSNAME.TableNumeric} no-border`,
		},

		{
			field: "",
			title: "",
			width: "100px",
			cell: (props) => (
				<GridCommandCellMultiple
					{...props}
					style={{}}
					items={[
						{
							onclick: prop.openNoteModal,
							iconName: ICON_NAMES.Note,
						},
						{
							onclick: prop.startDeletingLine,
							iconName: ICON_NAMES.Delete,
						},
					]}
				/>
			),
		},
	];

	return gridItems;
};

const itemRender = (
	li: React.ReactElement<HTMLLIElement>,
	itemProps: ListItemProps
) => {
	const itemChildren = [
		<span key={1} style={{ width: "40px" }}>
			&nbsp; {itemProps.dataItem.code}{" "}
		</span>,
		<span key={2}>&nbsp; {itemProps.dataItem.name} </span>,
	];

	return React.cloneElement(li, li.props, itemChildren);
};
// const NumericalHeader: FC<GridHeaderCellProps> = (props) => {
// 	return <span>{props.title}</span>;
// };
